import React, { useState } from 'react';
import { educationCards } from '../mockData';

const EducationSection = () => {
  const [focusedCard, setFocusedCard] = useState(null);
  
  return (
    <section className="py-12 px-4 bg-[#040c14] relative overflow-hidden">
      {/* Abstract background with multiple organic shapes */}
      <div className="absolute inset-0 opacity-15 pointer-events-none">
        <div className="abstract-blob animate-float-delayed" style={{ 
          top: '5%', 
          left: '15%', 
          width: '450px', 
          height: '450px', 
          background: 'radial-gradient(circle, rgba(255, 101, 0, 0.3), transparent 70%)',
          filter: 'blur(70px)'
        }}></div>
        <div className="abstract-blob animate-float" style={{ 
          top: '40%', 
          right: '10%', 
          width: '400px', 
          height: '400px', 
          background: 'radial-gradient(circle, rgba(255, 180, 100, 0.2), transparent 70%)',
          filter: 'blur(80px)'
        }}></div>
        <div className="abstract-blob animate-float-slow" style={{ 
          bottom: '10%', 
          left: '25%', 
          width: '350px', 
          height: '350px', 
          background: 'radial-gradient(circle, rgba(255, 140, 50, 0.25), transparent 70%)',
          filter: 'blur(75px)'
        }}></div>
      </div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <h2 className="text-4xl md:text-6xl font-bold text-white mb-4 text-center">
          The Book-to-Film <span className="text-[#FF6500]">Framework</span>
        </h2>
        <p className="text-lg text-[#aaa] text-center mb-8 max-w-3xl mx-auto">
          Why the traditional publishing-to-screen path is broken, and how to fix it.
        </p>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 relative">
          {educationCards.map((card) => {
            const isFocused = focusedCard === card.id;
            const isOtherFocused = focusedCard !== null && focusedCard !== card.id;
            
            return (
              <div 
                key={card.id}
                onMouseEnter={() => setFocusedCard(card.id)}
                onMouseLeave={() => setFocusedCard(null)}
                className={`bg-[#0a1525] rounded-lg border overflow-hidden cursor-pointer ${
                  isFocused 
                    ? 'framework-card-focused' 
                    : isOtherFocused
                    ? 'framework-card-dimmed'
                    : 'framework-card-normal'
                }`}
              >
                <div className="aspect-[4/3] w-full overflow-hidden">
                  <img 
                    src={card.image} 
                    alt={card.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-3">
                  <h3 className="text-sm font-semibold text-white mb-1 line-clamp-2">{card.title}</h3>
                  <p className="text-xs text-[#aaa] leading-relaxed line-clamp-3">{card.description}</p>
                </div>
              </div>
            );
          })}
          
          {/* Backdrop overlay when a card is focused */}
          {focusedCard && (
            <div 
              className="fixed inset-0 bg-black/70 z-30 animate-fadeIn pointer-events-none"
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default EducationSection;